import styled, { StyledComponent } from 'styled-components'
import Button from './Button'
import { ButtonProps } from '../../elements/Button'
import Group, { GroupProps } from './Group'
import Row, { RowProps } from './Row'

const Footer = styled.div`
  margin-top: 10px;
  margin-right: auto;
  margin-bottom: 10px;
  margin-left: auto;
  width: 100%;
  @media(max-width: 767px) {
    margin-top: 2px;
    margin-bottom: 2px;
    height: auto;
    max-height: 25%;
  }
` as Footer

Footer.Button = Button
Footer.Group = Group
Footer.Row = Row

type Footer = StyledComponent<'div', any> & {
  Button: StyledComponent<'div', ButtonProps, any>
  // Description: StyledComponent<'p', any>
  Group: StyledComponent<'div', any, GroupProps>
  // Heading: StyledComponent<'p', any>
  Row: StyledComponent<'div', RowProps, any>
}

export default Footer
